import React from 'react';

import { useAccountState, useAccountActions } from './AccountContext';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PasswordUpdateForm from './PasswordUpdateForm';

const AccountPasswordUpdateModal = () => {
  const state = useAccountState();
  const { closePasswordUpdateModal } = useAccountActions();

  return (
    <StandardModal
      isOpen={state?.passwordUpdateModalIsOpen}
      contentLabel="Update Password"
      onRequestClose={() => {
        closePasswordUpdateModal();
      }}
    >
      <PasswordUpdateForm />
    </StandardModal>
  );
};

export default AccountPasswordUpdateModal;